/* 🤖 this file was generated by script */
export const wiconRoute = {
  name: 'route',
  data: `<svg viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11.5 5h.43c3.05 0 4.58 0 5.15.55a2 2 0 01.59 1.84c-.16.78-1.4 1.66-3.89 3.42L9.72 13.7c-2.49 1.76-3.73 2.64-3.89 3.42a2 2 0 00.59 1.84c.57.55 2.1.55 5.15.55h.93M8 5a3 3 0 11-6 0 3 3 0 016 0zm14 14a3 3 0 11-6 0 3 3 0 016 0z"/></svg>`,
};
